<script setup>
import {
	IonButton,
	IonCard,
	IonToolbar,
	IonButtons,
	IonCardContent,
	IonItem,
	IonCardTitle,
	IonCardSubtitle,
	IonCardHeader
} from '@ionic/vue'
import {QSkeleton} from "quasar";
</script>

<template>
  <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 model-card-container ion-no-margin ion-no-border">
	<ion-card class="model-card">
		<ion-toolbar style="--background:transparent">
			<ion-buttons style="padding-left: 8px;padding-right: 8px;">
				<ion-button>
					<q-skeleton style="opacity: 0.75;" animation="fade" width="26px" height="26px"
					            type="rect"/>
				</ion-button>
			</ion-buttons>

		</ion-toolbar>
		<ion-card-content class="card-content">
			<ion-item
					style="opacity:0.75;margin-top: -13px;--padding-start: 0;--inner-padding-end: 0;width: 100%;margin-bottom: -15px;padding-bottom: 20px;">
				<img alt="loading"
				     style="opacity:1;position:relative;left:10%;top:0;width:80%;padding-bottom: 50px;"
				     src="../assets/img/blank.png"/>
				<q-skeleton type="rect"
				            style="left:10%;position:absolute;margin-top: 30px;opacity:0.75;padding-bottom: 10px;margin-bottom: 22px;"
				            animation="fade"
				            height="130px" width="80%"/>
			</ion-item>
			<ion-card-header style="opacity:0.95;padding: 1px 10px">
				<ion-card-title style="margin-top:0;margin-bottom:0">
					<q-skeleton type="rect" animation="fade" width="70%" height="20px"/>
				</ion-card-title>
				<ion-card-subtitle style="margin-top:5px">
					<q-skeleton type="rect" animation="fade" width="30%" height="14px"/>
				</ion-card-subtitle>
			</ion-card-header>
		</ion-card-content>
	</ion-card>
  </div>
</template>

<style scoped>
.model-card-container {
  transition: opacity 1s;
  margin: 0;
  padding: 0;
  width: 100%;
}

.model-card {
  margin: 12px;
}

.card-content {
  padding-top: 0;
  padding-bottom: 8px;
}
</style>